import { render, staticRenderFns } from "./sample.vue?vue&type=template&id=5ed1b140&scoped=true&"
import script from "./sample.vue?vue&type=script&lang=js&"
export * from "./sample.vue?vue&type=script&lang=js&"
import style0 from "./sample.vue?vue&type=style&index=0&id=5ed1b140&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed1b140",
  null
  
)

export default component.exports